module.exports = __webpack_public_path__ + "img/05.a.147b9c37.webp";